module.exports = __webpack_public_path__ + "static/media/salesmanagement.130a3c0f.avif";